module.exports = __webpack_public_path__ + "static/media/hs3.25855bc9.jpg";